import { Clock } from 'lucide-react';

import type { ApiHTTPError } from '@/lib/api/client';

// True when a verify/callback API error is the backend's Session.Expired guard
// (409) — the session's validity window (Settings → Session Expiry) has elapsed.
// The beforeError hook in the api client attaches the ProblemDetails to
// error.data, so we can read the error code without re-parsing the response.
export function isSessionExpiredError(error: unknown): boolean {
  const data = (error as ApiHTTPError | undefined)?.data;
  return Boolean(data?.errors?.some((e) => e.code === 'Session.Expired'));
}

// Shown when the applicant tries to continue after the session has expired.
// Deliberately distinct from the red "rejected" screen — this is a neutral/amber
// timeout, not a verification failure.
export function SessionExpiredScreen() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center px-4 text-center">
      <div className="mb-6 flex h-[110px] w-[110px] items-center justify-center rounded-full bg-[#F59E0B]">
        <Clock size={56} strokeWidth={2.5} color="white" />
      </div>
      <h2 className="mb-2 text-[length:var(--text-20)] font-semibold leading-tight text-[#B45309]">
        Session expired
      </h2>
      <p className="max-w-xs text-[length:var(--text-14)] text-[#666666]">
        This verification link has timed out for your security. Please start a new session to
        continue.
      </p>
    </div>
  );
}
